import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  overlayTitle: {
    fontSize: 24,
    fontWeight: 600,
  },
  unpairedPlayersContainer: {
    height: '80vh',
    overflowY: 'scroll',
  },
  closeIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  eligibilityError: {
    fontSize: '15px !important',
    textAlign: 'end',
  },
}));
